module.exports = __webpack_public_path__ + "media/images/status-current-issue-ac23cbea.svg";